<template>
    <div class="mt-5 request-type-bloc">
        <h2 class="ml-5 mb-5">{{ title }} ({{ requests.length }})</h2>

        <v-card v-for="(request, index) in requests" class="mb-3">
            <v-card-text>
                <div class="d-md-flex justify-content-between">
                    <div class="d-flex">
                        <div v-if="request.overrideTitle"
                             class="mr-3 mt-auto mb-auto">
                            <v-img height="60px"
                                   width="60px"
                                   style="border-radius: 250px"
                                   src="/images/handshake.png">
                            </v-img>
                        </div>
                        <div v-else-if="request.providerData !== undefined && request.providerData.medias.length"
                             class="mr-3 mt-auto mb-auto">
                            <v-img height="60px"
                                   width="60px"
                                   style="border-radius: 250px"
                                   :src="(request.providerData.medias[0].thumbnail_url !== null) ?
                                          request.providerData.medias[0].thumbnail_url :
                                          request.providerData.medias[0].url">
                            </v-img>
                        </div>
                        <div v-else style="width: 72px" class="pro-top-menu">
                            <v-img height="60px"
                                   width="60px"
                                   style="border-radius: 250px"
                                   src="/images/building.svg">
                            </v-img>
                        </div>

                        <div>
                            <div v-if="request.overrideTitle">
                            <span class="replaced-title" style="font-size: 21px !important;"
                                  v-html="request.title"></span>
                            </div>

                            <div v-else-if="request.provider && request.provider.last_version && request.providerData">
                                <div class="d-md-flex ml-2 mb-2">
                                    <div class="category-chip text-center mr-3">{{ request.providerData.category.label
                                        }}
                                    </div>
                                    <h4 class="mt-auto mb-auto" style="font-size: 21px">
                                        {{ request.provider.last_version.name }}</h4>
                                </div>

                                <div class="ml-2">{{ generateAddress(request.providerData.localisation) }}</div>
                            </div>

                            <div v-else-if="request.providerData">
                                <div class="d-flex mb-2 ml-2">
                                    <div class="category-chip text-center mr-3">{{ request.providerData.category.label
                                        }}
                                    </div>
                                    <h4 class="mt-auto mb-auto" style="font-size: 21px">{{ request.providerData.name
                                        }}</h4>
                                </div>

                                <div class="ml-2">{{ generateAddress(request.providerData.localisation) }}</div>
                            </div>

                            <div v-else>
                                <div class="d-flex ml-2">
                                    <h4 style="font-size: 21px">{{ request.name }}</h4>
                                </div>
                            </div>

                            <div class="mt-2 ml-2 mb-auto">
                                <small class="font-italic">
                                    Le {{ formatDate(request.created_at, false) }} par {{ request.account_name }}
                                </small>
                            </div>
                        </div>
                    </div>

                    <div class="mt-auto mb-auto">
                        <v-btn class="default-button text-none"
                               :class="{'warning-button': request.state === 'DRAFT'}"
                               @click="openForm(request)">
                            <div v-if="request.state !== 'DRAFT' && request.state !== 'SAVING_DRAFT'">
                                <span v-if="request.type === 'CADH'">Compléter mon {{
                                        request.globalPartenariatConfig
                                    }}</span>
                                <span v-else>Compléter mes informations
                                    <span v-if="request.aspect === 'business'"><br>Tourisme d'affaires</span>
                                    <span v-else-if="request.aspect === 'winter'"><br>Hiver</span>
                                    <span v-else-if="request.aspect === 'summer'"><br>Eté</span>
                                </span>
                            </div>
                            <span v-else>Finaliser mon brouillon
                                <span v-if="request.aspect === 'business'"><br>Tourisme d'affaires</span>
                                <span v-else-if="request.aspect === 'winter'"><br>Hiver</span>
                                <span v-else-if="request.aspect === 'summer'"><br>Eté</span>
                            </span>
                        </v-btn>

                        <div class="text-right mt-3 font-italic text-decoration-underline cursor-pointer"
                             v-if="request.type === 'CADH'"
                             @click="openCancelAdhModal(request, index)">
                            <p v-if="request.globalPartenariatConfig === 'partenariat'" class="mb-0">Vous ne souhaitez
                                pas devenir partenaire ?</p>
                            <p v-else class="mb-0">Vous ne souhaitez pas adhérer ?</p>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>

        <v-dialog content-class="pro-dialog" v-model="cancelAdhModal" max-width="600px">
            <v-card>
                <v-card-title>
                    <h2 class="headline-title">Vous ne souhaitez pas adhérer ?</h2>
                </v-card-title>
                <v-card-text>
                    <v-spacer></v-spacer>
                    <div v-if="currentRequest && currentRequest.globalPartenariatConfig === 'adhésion'">
                        Je confirme que je ne souhaite pas adhérer à {{ currentRequest.organism }} et ne souhaite plus
                        être
                        sollicité cette année à ce titre.
                    </div>

                    <div v-if="currentRequest && currentRequest.globalPartenariatConfig === 'partenariat'">
                        Je confirme que je ne souhaite pas devenir partenaire de {{ currentRequest.organism }} et ne
                        souhaite plus être
                        sollicité cette année à ce titre.
                    </div>

                    <div class="d-flex justify-content-end gap-10 mt-3">
                        <v-btn @click="cancelAdhModal = false">Annuler</v-btn>
                        <v-btn class="default-button" @click="cancelForm">Confirmer</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "RequestBloc",
    props: ["title", "requests"],
    data() {
        return {
            cancelAdhModal: false,
            currentRequest: null,
            requestIndex: null,
        }
    },
    methods: {
        generateAddress(localisation) {
            let address = ""

            if (localisation !== null) {
                if (localisation.address !== null) {
                    address += localisation.address
                }

                if (localisation.postal_code !== null) {
                    if (address !== "") {
                        address += ", "
                    }

                    address += localisation.postal_code
                }

                if (localisation.commune !== null) {
                    if (address !== "") {
                        address += " "
                    }

                    address += localisation.commune.name
                }
            }

            return address
        },
        openForm(request) {
            if (request.type === "CADH") {
                let contact = request.provider !== undefined ? request.provider.contact : request.entity.contact
                let uri = "/espace-pro/" + contact.token + "/adhesion/" + request.token

                this.$router.push(uri)
            } else {
                this.$router.push(request.url)
            }
        },
        openCancelAdhModal(request, index) {
            this.currentRequest = request
            this.cancelAdhModal = true
            this.requestIndex = index
        },
        cancelForm() {
            let payload = {
                state: "REFUSED",
                cadhFormId: this.currentRequest.id,
            }

            this.$global.loading = true

            this.$http.post("campaigns/cadh/update-state", payload).then(res => {
                this.cancelAdhModal = false

                this.$global.loading = false

                this.$global.$emit("remove-request")
            })
        },
    },
}
</script>